export default "__VITE_ASSET__mdErBvds__"